import React, { Fragment, useEffect } from 'react';
import { Grid, List, ListItem, ListItemIcon, ListItemText, Divider } from '@material-ui/core';
import { autorun } from 'mobx';
import { observer } from 'mobx-react-lite';
import { Link, useRouteMatch } from 'react-router-dom';
import cn from 'classnames';
import { Amount, ScreenLoader, EmptyState } from 'components';
import { anketsStore, propertiesStore } from 'stores';
import { ru } from 'locale';
import { NoData as NoDataBg } from 'resources/images';
import { icons } from '../../GuarantorsScreen.mock';
import useStyles from './PropertiesList.styles';

const PropertiesList = observer(() => {
  const classes = useStyles();
  const { path } = useRouteMatch();
  const { fetchState, properties } = propertiesStore;
  const hasItems = properties.length !== 0;

  useEffect(
    () =>
      autorun(() => {
        propertiesStore.getProperties(anketsStore.anketId);
      }),
    [],
  );

  const renderAmount = depositCost => {
    return <Amount amount={{ value: depositCost, currency: { code: 'RUR', minority: 0 } }} />;
  };

  const renderProperties = () => {
    if (!hasItems) {
      return (
        <EmptyState
          image={{ source: NoDataBg, alt: ru.listOfProperties }}
          title={ru.emptyList(ru.listOfProperties)}
        />
      );
    }

    return (
      <List component="nav" aria-label={ru.properties}>
        {properties.map(item => {
          const Icon = icons[item.type];

          return (
            <Fragment key={item.id}>
              <ListItem key={item.id} button component={Link} to={`${path}/${item.id}`}>
                <ListItemIcon>
                  <Icon />
                </ListItemIcon>
                <ListItemText
                  primary={item.description}
                  secondary={renderAmount(item.depositCost)}
                />
              </ListItem>
              <Divider />
            </Fragment>
          );
        })}
      </List>
    );
  };

  return (
    <>
      {fetchState === 'pending' && <ScreenLoader />}

      <Grid
        container
        item
        direction="column"
        justify={hasItems ? 'flex-start' : 'center'}
        className={cn({
          [classes.content]: !hasItems,
        })}
      >
        {fetchState === 'fulfilled' && renderProperties()}
      </Grid>
    </>
  );
});

export default PropertiesList;
